module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "head",
    staticClass: "app-header navbar"
  }, [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none mr-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.isLogin) ? _c('b-nav-item-dropdown', {
    staticClass: "m-2",
    attrs: {
      "id": "ddown-split",
      "size": "sm",
      "split": "",
      "text": _vm.loginName,
      "variant": "outline-primary"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.doLogout
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" 注销")])], 1) : _c('b-nav-item', {
    staticClass: "d-md-down-none",
    on: {
      "click": _vm.doLogin
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-in"
  }), _vm._v(" 登录\n    ")]), _vm._v(" "), _c('b-nav-text', [_vm._v(" ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-26872ec7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 9AG2
// module chunks = 4